import { AnalyticsTracker } from "./AnalyticsTracker";

export default AnalyticsTracker;
